import React from 'react'
import { ColorSerializerProps } from './type'

export const ColorSerializer: React.FC<ColorSerializerProps> = (props) => {
  const { hex } = props.mark

  return <span style={{ color: hex }}>{props.children[0]}</span>
}
